import React, { useContext} from 'react';
import { NavLink } from "react-router-dom";
import { UserContext } from "../../providers/user-provider";

const AdminNavigation = () => {
	const user = useContext(UserContext);
	const userRole = user && user.role;

	return (
		<nav className="navigation admin-navigation">
			<ul>
				<li>
					<NavLink exact to="/">Home</NavLink>
				</li>
	      <li>
	        <NavLink to="/albums">Album Reviews</NavLink>
	      </li>
				<li>
	        <NavLink to="/features">Features</NavLink>
	      </li>
				{ userRole === 'owner' &&
		      <li>
		        <NavLink to="/about">
		          About Us Page
		        </NavLink>
		      </li>
				}
	    </ul>
		</nav>
	);
}

export default AdminNavigation;
